<script lang="ts">
</script>


<!-- <spotlight-card ></spotlight-card> -->

<div hx-ext="sse" 
  hx-request="{{'with-credantials':false }}"
  sse-connect="https://spotlight.val.run/spotlight" 
  sse-swap="spotlight" hx-swap="innerHTML transition:true swap:1s" 
  class="z-10 h-full w-full max-h-screen opacity-100">
</div> 
